var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "hasNext": "false",
      "title": _vm.header.title,
      "description": _vm.header.description,
      "debug": _vm.report
    }
  }, [_c('v-card', {
    staticClass: "pl-3 pr-3",
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_vm.email ? _c('div', {
    staticClass: "pl-1 text"
  }, [_c('span', [_vm._v(" Nach dem Abschicken erhalten Sie eine Bestätigung an "), _c('b', [_vm._v(_vm._s(_vm.email))])])]) : _vm._e(), _c('v-checkbox', {
    ref: "reviewed",
    staticClass: "padded",
    attrs: {
      "rules": _vm.reportReviewedRules,
      "label": "Die eingegebenen Daten entsprechen der Wahrheit und wurden von mir auf Vollständigkeit geprüft."
    },
    model: {
      value: _vm.isReviewed,
      callback: function callback($$v) {
        _vm.isReviewed = $$v;
      },
      expression: "isReviewed"
    }
  }), _c('v-checkbox', {
    ref: "privacy",
    staticClass: "padded",
    attrs: {
      "rules": [function (v) {
        return !!v || 'Bitte die Datenschutzerklärung lesen und zustimmen.';
      }]
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Ich habe die "), [_c('a', {
          attrs: {
            "href": _vm.privacyPolicyLink,
            "target": "_blank"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v(" Datenschutzerklärung ")])], _vm._v(" gelesen und erkläre mich mit dieser einverstanden. ")], 2)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isPrivacyChecked,
      callback: function callback($$v) {
        _vm.isPrivacyChecked = $$v;
      },
      expression: "isPrivacyChecked"
    }
  }), _c('v-checkbox', {
    staticClass: "padded",
    attrs: {
      "label": "Ich bin damit einverstanden, zu Werbezwecken von Ihnen oder einer Ihrer Partnerwerkstätten kontaktiert zu werden."
    },
    model: {
      value: _vm.isMarketingContactAllowed,
      callback: function callback($$v) {
        _vm.isMarketingContactAllowed = $$v;
      },
      expression: "isMarketingContactAllowed"
    }
  }), _c('v-row', {
    staticClass: "justify-center align-center pt-12"
  }, [_c('v-btn', {
    staticClass: "submitButton",
    attrs: {
      "color": "success",
      "rounded": "",
      "x-large": "",
      "disabled": !_vm.isDone,
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-send ")]), _vm._v(" Jetzt Abschicken! ")], 1)], 1)], 1), _c('v-overlay', {
    attrs: {
      "value": _vm.isLoading
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }